import React from 'react';
import { useParams } from 'react-router-dom';
import CandidateList from 'src/components/newRecruiterFlow/campus/campusCandidateListing/CandidateList';

const HiringAssessmentCandidatePage = () => {
	const { hiringAssessmentId } = useParams();
	return <div>{/* <CandidateList /> */}</div>;
};

export default HiringAssessmentCandidatePage;
